// extracted by mini-css-extract-plugin
export default {"region":"region---GjQNe","bar":"bar---ntTv8"};